import React, { useState } from "react";
import { IconButton, ListActionButtonProps, Modal, Spinner, TextField } from "sprint-common-web";

import { useManzanitaPresetApi } from "../../../../common/api/orders-api/manzanita-preset/useManzanitaPresetApi";
import { ManzanitaPresetListingItem } from "../ManzanitaPresetListingItem";

type ManzanitaPresetPreviewButtonProps = ListActionButtonProps<ManzanitaPresetListingItem>;

export const ManzanitaPresetPreviewButton: React.VFC<ManzanitaPresetPreviewButtonProps> = ({
    itemId
}: ManzanitaPresetPreviewButtonProps) => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [content, setContent] = useState<string>("");

    const { getManzanitaPresetPreviewById } = useManzanitaPresetApi();

    const openModal = async () => {
        setIsModalOpen(true);
        setIsLoading(true);

        getManzanitaPresetPreviewById(itemId)
            .then((response) => {
                setContent(response.encodedPreset);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <IconButton iconProps={{ iconName: "OpenFile" }} tooltipContent="Open preset preview" onClick={openModal} />
            <Modal isOpen={isModalOpen} headerText="Preset preview" onDismiss={closeModal}>
                {!isLoading ? (
                    <TextField label="Content" multiline={true} rows={20} value={content} />
                ) : (
                    <Spinner></Spinner>
                )}
            </Modal>
        </>
    );
};
